<template>
    <div id="productList">
      <div v-if="!isMob" class="pc">
        <div class="card" v-for="item in data" :key="item.id" @click="linkTo(item.id)">
            <div class="img">
              <img :src="baseUrl+item.cover_img" alt=""/>
            </div>
            <div class="text">
              <span>{{item.name}}</span>
            </div>
        </div>
      </div>  
      <div v-if="isMob" class="mob">
        <div class="card" v-for="item in data" :key="item.id" @click="linkTo(item.id)">
            <div class="img">
              <img :src="baseUrl+item.cover_img_text" alt=""/>
            </div>
            <div class="text">
              <span>{{item.name}}</span>
            </div>
        </div>
      </div>      
    </div>
</template>
<script>
export default {  
  props: {
    data: {
      type:Array,
      default:()=>[]
    },
    isMob:{
      type:Boolean,
      default:false
    }
  },
  watch: {
  },
  data() {
    return {
      baseUrl:window.config.apiUrl,
    }
  },
  methods: {
    linkTo(id){
      window.open("/#/productDetail?id="+id,"_blank");
    }
  },
  mounted() {
    
  }
}
</script>
<style lang="scss" scoped src="@/assets/css/productList.scss"></style>